import * as Immutable from "immutable";
import WidgetConfig from "views/logic/widgets/WidgetConfig";
const _LogViewWidgetConfig = class _LogViewWidgetConfig extends WidgetConfig {
  constructor(after, fields, size, sort, tieBreaker) {
    super();
    this._value = { after, fields, size, sort, tieBreaker };
  }
  get after() {
    return this._value.after;
  }
  get fields() {
    return this._value.fields;
  }
  get size() {
    return this._value.size;
  }
  get sort() {
    return this._value.sort;
  }
  get tieBreaker() {
    return this._value.tieBreaker;
  }
  withFields(fields) {
    return this.toBuilder().fields(fields).build();
  }
  toBuilder() {
    return new Builder(Immutable.Map(this._value));
  }
  toJSON() {
    const { after, fields = Immutable.OrderedSet(), size, sort, tieBreaker } = this._value;
    return {
      after,
      fields: fields.toArray(),
      size,
      sort,
      tie_breaker: tieBreaker
    };
  }
  static builder() {
    return new Builder().fields(Immutable.OrderedSet());
  }
  static fromJSON(value) {
    const { after, fields, size, sort, tie_breaker } = value;
    return new _LogViewWidgetConfig(after, Immutable.OrderedSet(fields), size, sort, tie_breaker);
  }
  static createDefault() {
    return new _LogViewWidgetConfig(
      void 0,
      _LogViewWidgetConfig.defaultFields,
      _LogViewWidgetConfig.defaultSize,
      _LogViewWidgetConfig.defaultSortDirection,
      void 0
    );
  }
};
_LogViewWidgetConfig.defaultFields = Immutable.OrderedSet(["timestamp", "source", "message"]);
_LogViewWidgetConfig.defaultSortDirection = "DESC";
_LogViewWidgetConfig.defaultSize = 100;
let LogViewWidgetConfig = _LogViewWidgetConfig;
export {
  LogViewWidgetConfig as default
};
class Builder {
  constructor(value = Immutable.Map()) {
    this.value = value;
  }
  after(value) {
    return new Builder(this.value.set("after", value));
  }
  fields(value) {
    return new Builder(this.value.set("fields", value));
  }
  size(value) {
    return new Builder(this.value.set("size", value));
  }
  sort(value) {
    return new Builder(this.value.set("sort", value));
  }
  tieBreaker(value) {
    return new Builder(this.value.set("tieBreaker", value));
  }
  build() {
    const { after, fields, size, sort, tieBreaker } = this.value.toObject();
    return new LogViewWidgetConfig(after, fields, size, sort, tieBreaker);
  }
}
